import { ChangeEvent, FC } from "react";
import { Control, Controller, RegisterOptions } from "react-hook-form";
import TextField, { TextFieldProps } from "./TextField";

export enum INPUT_TEXT_TYPE {
  PASSWORD = "password",
  TEXT = "text",
  NUMBER = "number",
}

export type InputTextProps = {
  control: Control<any>;
  name: string;
  rules?: Omit<
    RegisterOptions<any, string>,
    "disabled" | "setValueAs" | "valueAsNumber" | "valueAsDate"
  >;
  isError?: boolean;
  type?: INPUT_TEXT_TYPE;
  isRequired?: boolean;
  readonly?: boolean;
} & TextFieldProps;

const InputText: FC<InputTextProps> = ({
  control,
  name,
  rules,
  style,
  isError,
  type = INPUT_TEXT_TYPE.TEXT,
  isRequired= false,
  readOnly = false,
  ...rest
}) => {
  return (
    <Controller
      control={control}
      rules={rules}
      name={name}
      render={({ field, fieldState }) => {
        const errorMessage = fieldState?.error?.message;
        const fieldValue = field?.value ? field?.value?.toString() : "";

        const handleChange = (
          e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
        ) => {
          if (type === "number") {
            if (e.target.value === "" || /^[0-9\b]+$/.test(e.target.value)) {
              field.onChange(e);
            }
          } else {
            field.onChange(e);
          }
        };

        const errorEnabled = !!errorMessage || isError;

        return (
          <TextField
            fieldValue={fieldValue}
            handleChange={handleChange}
            errorEnabled={errorEnabled}
            type={type}
            isRequired={isRequired}
            readOnly={readOnly}
            errorMessage={errorMessage}
            {...rest}
          />
        );
      }}
    />
  );
};

export default InputText;
